import React from 'react';
import {
  CustomCard,
  CustomCardContent,
  InsightsCardTitle,
  InsightsCardRow,
  InsightsValue,
} from 'spw-esa-projects/building-details/occupancy-and-utilization/cards/styles';
import {
  OccupancyAndUtilizationSummaries,
  RoundInsights,
  SeatsSummary,
} from 'spw-redux/modules/ou/types';
import { Category } from 'spw-redux/modules/space_types/types';
import { ALL_CATEGORIES } from 'spw-esa-projects/building-details/occupancy-and-utilization/cards/constants';
import { TabValue } from 'spw-esa-projects/building-details/occupancy-and-utilization/types';
import { Grid } from '@mui/material';
import { MarginTop8 } from 'spw-shared/globalComponents/containers';
import CategorySeatsSummary from 'spw-esa-projects/building-details/occupancy-and-utilization/cards/category-seats-summary';
import CategoryDotSection from 'spw-esa-projects/building-details/occupancy-and-utilization/cards/category-dot-section';
import {
  asPercentageRounded,
  fixedNumberWithCommas,
  numberWithCommasOrDash,
} from 'spw-shared/utils';

type Props = {
  selectedCategory: TabValue;
  categories: Category[];
  summaries: OccupancyAndUtilizationSummaries | null;
};

const SeatsValue = ({ field, value }: { field: string; value: number }) => {
  if (field === 'averageUtilization')
    return value === undefined ? '--' : asPercentageRounded(value);

  if (field === 'averageSeatsUsedPerSpace')
    return value !== undefined ? fixedNumberWithCommas(value, 1) : '--';

  return numberWithCommasOrDash(value);
};

const SeatsCard = ({ selectedCategory, categories, summaries }: Props) => {
  return (
    <Grid container>
      <Grid item xs={selectedCategory === ALL_CATEGORIES ? 12 : 6}>
        <CustomCard elevation={0}>
          <CustomCardContent>
            <InsightsCardTitle>
              OCCUPANCY & UTILIZATION SUMMARY
              {selectedCategory !== ALL_CATEGORIES ? ' OF SEATS' : ''}
            </InsightsCardTitle>
            <MarginTop8 />
            {selectedCategory === ALL_CATEGORIES ? (
              <Grid container>
                <Grid item xs={6}>
                  <CategorySeatsSummary
                    category={selectedCategory}
                    seatsSummary={summaries[ALL_CATEGORIES]?.seats}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CategoryDotSection categories={categories} />
                  {[
                    'existing',
                    'observed',
                    'inUse',
                    'averageUtilization',
                    'averageSeatsUsedPerSpace',
                  ].map((valueKey) => {
                    return (
                      <InsightsCardRow key={valueKey}>
                        <Grid container>
                          {categories.map((category) => {
                            const roundInsights: RoundInsights =
                              summaries[
                                category as keyof OccupancyAndUtilizationSummaries
                              ];

                            const seatsSummary: SeatsSummary =
                              roundInsights?.seats || ({} as SeatsSummary);

                            return (
                              <Grid item xs={3} key={category}>
                                <InsightsValue>
                                  <SeatsValue
                                    field={valueKey}
                                    value={
                                      seatsSummary[
                                        valueKey as keyof SeatsSummary
                                      ]
                                    }
                                  />
                                </InsightsValue>
                              </Grid>
                            );
                          })}
                        </Grid>
                      </InsightsCardRow>
                    );
                  })}
                </Grid>
              </Grid>
            ) : (
              <CategorySeatsSummary
                category={selectedCategory}
                seatsSummary={
                  summaries[
                    selectedCategory as keyof OccupancyAndUtilizationSummaries
                  ]?.seats
                }
              />
            )}
          </CustomCardContent>
        </CustomCard>
      </Grid>
    </Grid>
  );
};

export default SeatsCard;
